import React from 'react';
import { string, node } from 'prop-types';
import cx from 'classnames';
import style from './StretchStack.module.scss';
import { Stack } from '@chaser/components';

const StretchStack = ({ children, className, ...rest }) => {
  return (
    <Stack display="flex" flexDirection="column" className={cx(style.stack, className)} {...rest}>
      {children}
    </Stack>
  );
};

StretchStack.propTypes = {
  children: node,
  className: string,
};

export default StretchStack;
